export const contactsTabDataHandler = [
  {
    name: "Employee Level Contacts",
    value: "company",
  },
  {
    name: "Extracted Contacts",
    value: "ai",
  },
];
